import { fundRankingConstants } from '../_constants/fund-ranking.constants';

import {
  appendCategory,
  removeCategory,
  userCategoryFetching,
  userCategoryData,
  userCategoryError,
  setIsFetching,
  filterDataResult,
  resetDataResult,
  resetDataResultToObject,
  setDefaultQueriesFundRanking
} from '../_utils/fund-ranking.utils';

const initialState = {
  rank: {
    isFetching: false,
    data: {},
    errorMessage: null
  },
  fundRankInfo: {
    fundId: null,
    data: {},
    isFetching: false,
    errorMessage: null,
  },
  fundRankSearchResponse: {
    // fundId: null,
    currentPage: 1,
    totalPage: 1,
    data: [],
    isFetching: false,
    errorMessage: null,
  },
  favCategories: [],
  category: {
    isFetching: false,
    categories: [],
    errorMessage: null
  },
  userCategory: {
    userCategories: [],
    isFetching: false,
    errorMessage: undefined
  },
  navResponse: {
    navDate: '1Y',
    isFetching: false,
    data: [],
    errorMessage: null,
  },
  searchFilters: {
    isFetching: false,
    data: null,
    errorMessage: null,
    sortingFilter: [
      {
        header: '%UNIT Change',
        sortKey: 'unitChange',
      },
      {
        header: 'Morningstar rating',
        sortKey: 'morningStarRating',
      }
    ]
  },
  queries: {
    categoryCode: [],
    dividendPolicy: null,
    fundTypes: [],
    returnDateType: '1Y',
    morningStarRatings: [],
    investorRatings: [],
    purchaseFee: null,
    currencyPolicy: null,
    company: [],
    riskLevels: [],
    sortBy: 'return1Y',
    sortType: 'd',
    pageSize: 20
  },
  currentColumns: [],
  defaultColumns: [
    'charts',
    'nav',
    'return6M',
    'return1Y',
    'return3Y',
  ],
  columnList: [
    {
      header: 'อันดับ',
      sortKey: 'rank',
      section: 'main'
    },
    {
      header: 'ชื่อกองทุน',
      sortKey: 'fundCode',
      section: 'main'
    },
    {
      header: 'Chart',
      sortKey: 'charts',
      section: 'other'
    },
    {
      header: 'ความเสี่ยง',
      sortKey: 'riskLevel',
      section: 'other'
    },
    {
      header: 'Morningstar rating',
      sortKey: 'morningStarRating',
      section: 'other'
    },
    {
      header: 'NAV',
      sortKey: 'nav',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน YTD',
      sortKey: 'returnYTD',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน 1 สัปดาห์',
      sortKey: 'return1W',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน 1 เดือน',
      sortKey: 'return1M',
      section: 'other'
    },
    {
      header: ' ผลตอบแทน 3 เดือน',
      sortKey: 'return3M',
      section: 'other'
    },
    {
      header: ' ผลตอบแทน 6 เดือน',
      sortKey: 'return6M',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน 1 ปี',
      sortKey: 'return1Y',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน 3 ปี(ต่อปี)',
      sortKey: 'return3Y',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน 5 ปี(ต่อปี)',
      sortKey: 'return5Y',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน',
      sortKey: 'performance',
      section: 'other'
    },
    {
      header: '',
      sortKey: 'previous1Y',
      section: 'other'
    },
    {
      header: '',
      sortKey: 'previous2Y',
      section: 'other'
    },
    {
      header: '',
      sortKey: 'previous3Y',
      section: 'other'
    },
    {
      header: '',
      sortKey: 'previous4Y',
      section: 'other'
    },
    {
      header: '',
      sortKey: 'previous5Y',
      section: 'other'
    }
  ],
  highlightFunds: {
    period: '1Y',
    isFetching: false,
    data: [],
    errorMessage: null,
    periodList: [
      {
        name: '1 เดือน',
        value: '1M'
      },
      {
        name: '3 เดือน',
        value: '3M'
      },
      {
        name: '6 เดือน',
        value: '6M'
      },
      {
        name: '1 ปี',
        value: '1Y'
      }
    ]
  },
  colors: ['g-bg-red', 'g-bg-purple', 'g-bg-green', 'g-bg-blue', 'g-bg-pink', 'g-bg-cyan', 'g-bg-orange', 'g-bg-teal']
};

const fundRankingReducer = (state = initialState, action) => {
  switch (action.type) {
    case fundRankingConstants.UPDATE_FUND_RANKING_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach(attribute => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case 'sortBy': {
            if (value === 'nav' || value === 'riskLevel') {
              updateAttribute['sortType'] =  state.queries.sortBy === value && state.queries.sortType !== 'd' ? 'd' : 'a'
            } else {
              updateAttribute['sortType'] =  state.queries.sortBy === value && value && state.queries.sortType !== 'a' ? 'a' : 'd'
            }
            updateAttribute['sortBy'] = value;
            break;
          };
          case 'pageSize': {
            if (value !== state.queries.pageSize) {
              updateAttribute['pageSize'] = value
            }
            break;
          }
          default: updateAttribute[attribute] = value;
            break;
        };
      })

      return {
        ...state,
        queries: {
          ...state.queries,
          ...updateAttribute
        },
        fundRankSearchResponse: {
          ...state.fundRankSearchResponse,
          currentPage: 1
        }
      }
    };
    case fundRankingConstants.RESET_FUND_RANKING_QUERIES:
      return {
        ...state,
        queries: state.defaultQueries ?? initialState.queries
      };
    case fundRankingConstants.SET_DEFAULT_FUND_RANKING_QUERIES:
      return {
        ...state,
        queries: setDefaultQueriesFundRanking(state.queries, action.payload),
        defaultQueries: setDefaultQueriesFundRanking(state.queries, action.payload)
      };
    case fundRankingConstants.SET_CURRENT_FUND_RANKING_PAGE:
      return {
        ...state,
        fundRankSearchResponse: {
          ...state.fundRankSearchResponse,
          currentPage: action.payload ? action.payload : 1
        }
      };

    // Highlight funds
    case fundRankingConstants.SET_HIGHLIGHT_FUND_PERIOD:
      return {
        ...state,
        highlightFunds: {
          ...state.highlightFunds,
          period: action.payload
        }
      };
    case fundRankingConstants.FETCH_HIGHLIGHT_FUND_START:
      return {
        ...state,
        highlightFunds: {
          ...state.highlightFunds,
          isFetching: true
        }
      };
    case fundRankingConstants.FETCH_HIGHLIGHT_FUND_SUCCESS:
      return {
        ...state,
        highlightFunds: {
          ...state.highlightFunds,
          isFetching: false,
          data: action.payload
        }
      };
    case fundRankingConstants.FETCH_HIGHLIGHT_FUND_FAILURE:
      return {
        ...state,
        highlightFunds: {
          ...state.highlightFunds,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case fundRankingConstants.FETCH_RANK_START:
      return {
        ...state,
        rank: {
          ...state.rank,
          isFetching: true
        }
      };
    case fundRankingConstants.FETCH_RANK_SUCCESS:
      return {
        ...state,
        rank: {
          ...state.rank,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case fundRankingConstants.FETCH_RANK_FAILURE:
      return {
        ...state,
        rank: {
          ...state.rank,
          isFetching: false,
          data: {},
          errorMessage: action.payload
        }
      };
    case fundRankingConstants.SET_FUND_ID_RANK:
      return {
        ...state,
        fundRankInfo: {
          ...state.fundRankInfo,
          fundId: action.payload
        }
      };
    case fundRankingConstants.FETCH_FUND_RANK_START:
      return {
        ...state,
        fundRankInfo: setIsFetching(state.fundRankInfo)
      };
    case fundRankingConstants.FETCH_FUND_RANK_SUCCESS:
      return {
        ...state,
        fundRankInfo: filterDataResult(state.fundRankInfo, action.payload),
      };
    case fundRankingConstants.FETCH_FUND_RANK_FAILURE:
      return {
        ...state,
        fundRankInfo: resetDataResultToObject(state.fundRankInfo, action.payload)
      };
    case fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_START:
      return {
        ...state,
        searchFilters: setIsFetching(state.searchFilters)
      };
    case fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_SUCCESS:
      return {
        ...state,
        searchFilters: filterDataResult(state.searchFilters, action.payload),
      };
    case fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_FAILURE:
      return {
        ...state,
        searchFilters: resetDataResultToObject(state.searchFilters, action.payload)
      };
    case fundRankingConstants.SET_RANKING_TOTAL_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    case fundRankingConstants.FETCH_RANKINGS_START:
      return {
        ...state,
        fundRankSearchResponse: {
          ...state.fundRankSearchResponse,
          isFetching: true
        }
      };
    case fundRankingConstants.FETCH_RANKINGS_SUCCESS:
      return {
        ...state,
        fundRankSearchResponse: {
          ...state.fundRankSearchResponse,
          isFetching: false,
          errorMessage: null,
          totalPage: action.payload?.totalPage ?? 1,
          currentPage: action.payload?.currentPage ?? 1,
          data: action.payload?.items ?? []
        }
      };
    case fundRankingConstants.FETCH_RANKINGS_FAILURE:
      return {
        ...state,
        fundRankSearchResponse: {
          ...state.fundRankSearchResponse,
          isFetching: false,
          errorMessage: action.payload,
          currentPage: 1,
          totalPage: 1,
          data: []
        }
      };
    case fundRankingConstants.UPDATE_NAV_DATE_FUND_RANKING:
      return {
        ...state,
        navResponse: {
          ...state.navResponse,
          navDate: action.payload
        }
      };
    case fundRankingConstants.SET_NAV_TYPE_RANKING:
      return {
        ...state,
        navResponse: {
          ...state.navResponse,
          type: action.payload
        }
      };
    case fundRankingConstants.FETCH_NAV_RANKINGS_START:
      return {
        ...state,
        navResponse: setIsFetching(state.navResponse)
      };
    case fundRankingConstants.FETCH_NAV_RANKINGS_SUCCESS:
      return {
        ...state,
        navResponse: filterDataResult(state.navResponse, action.payload)
      };
    case fundRankingConstants.FETCH_NAV_RANKINGS_FAILURE:
      return {
        ...state,
        navResponse: resetDataResult(state.navResponse, action.payload)
      };
    case fundRankingConstants.FETCH_CATEGORIES_START:
      return {
        ...state,
        category: {
          ...state.category,
          isFetching: true
        }
      };
    case fundRankingConstants.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        category: {
          ...state.category,
          categories: action.payload,
          isFetching: false
        }
      };
    case fundRankingConstants.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        category: {
          ...state.category,
          isFetching: false,
          categories: [],
          errorMessage: action.payload
        }
      };
    case fundRankingConstants.UPDATE_CATEGORIES:
      return {
        ...state,
        favCategories: action.payload
      };
    case fundRankingConstants.APPEND_CATEGORY:
      return {
        ...state,
        favCategories: appendCategory(action.payload, state.favCategories)
      };
    case fundRankingConstants.REMOVE_CATEGORY:
      return {
        ...state,
        favCategories: removeCategory(action.payload, state.favCategories)
      };
    case fundRankingConstants.FETCH_USER_CATEGORIES_START:
      return {
        ...state,
        userCategory: userCategoryFetching(state.userCategory)
      };
    case fundRankingConstants.FETCH_USER_CATEGORIES_SUCCESS:
      return {
        ...state,
        userCategory: userCategoryData(state.userCategory, action.payload)
      };
    case fundRankingConstants.FETCH_USER_CATEGORIES_FAILURE:
      return {
        ...state,
        userCategory: userCategoryError(state.userCategory, action.payload)
      };
    case fundRankingConstants.RESET_USER_CATEGORIES:
        return {
          ...state,
          userCategory: userCategoryData(state.userCategory, [])
      };
    case fundRankingConstants.UPDATE_USER_CATEGORIES:
        return {
          ...state,
          userCategory: {
            ...state.userCategory,
            ...action.payload
          }
      };
    case fundRankingConstants.UPDATE_FUND_RANKING_TABLE_COLUMNS:
      return {
        ...state,
        currentColumns: action.payload ?? []
      };
    default:
      return state;
  }
};

export default fundRankingReducer;
